var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9991 12.2988V45.0988H12.2991V16.3988C12.2991 14.1345 14.1347 12.2988 16.3991 12.2988H40.9991ZM69.6991 65.5988V36.8988H45.0991V69.6988H65.5991C67.8634 69.6988 69.6991 67.8632 69.6991 65.5988ZM40.9991 69.6988V49.1988H12.2991V65.5988C12.2991 67.8632 14.1347 69.6988 16.3991 69.6988H40.9991ZM65.5991 40.9988H49.1991V65.5988H65.5991V40.9988ZM16.3991 53.2988H36.8991V65.5988H16.3991V53.2988ZM16.3991 16.3988H36.8991V40.9988H16.3991V16.3988ZM65.5991 12.2988C67.8634 12.2988 69.6991 14.1345 69.6991 16.3988V32.7988H45.0991V12.2988H65.5991ZM49.1991 16.3988H65.5991V28.6988H49.1991V16.3988Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bca88318.svg";
export { ForwardRef as ReactComponent };